var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "section-book-cleaner-from-profile form-book-cleaner" },
    [
      _c("div", { staticClass: "px-3 pt-3 pb-2" }, [
        _c("div", { staticClass: "form-group" }, [
          _c("h4", { staticClass: "pb-2" }, [
            _vm._v(
              _vm._s(_vm.$t("message.booking.new_booking.choose_a_service"))
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "select-jumbo" }, [
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.parentServiceId,
                    expression: "parentServiceId"
                  }
                ],
                staticClass: "form-control",
                on: {
                  change: [
                    function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.parentServiceId = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    },
                    _vm.setParentService
                  ]
                }
              },
              _vm._l(_vm.professional.professional_services, function(item) {
                return _c("option", { domProps: { value: item.service_id } }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm._f("multiLangName")(_vm.getService(item.service_id))
                      ) +
                      "\n          "
                  )
                ])
              }),
              0
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _vm.professionalCalendar
        ? _c("section", [
            _vm.parentService && _vm.parentService.can_book_package
              ? _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col" },
                    [
                      _c("booking-plan", {
                        attrs: { packageType: _vm.packageType },
                        on: { selectPackageType: _vm.selectPackageType }
                      })
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.state.userPlaces &&
            _vm.checkUserPlaces(
              _vm.state.userPlaces,
              _vm.professional.province_id
            )
              ? _c("div", { staticClass: "row mt-2" }, [
                  _c("div", { staticClass: "col-12" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c("h4", { staticClass: "pb-2" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("message.booking.booking_step.my_place")
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "select-jumbo" }, [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.selectedUserPlaceId,
                                expression: "selectedUserPlaceId"
                              }
                            ],
                            staticClass: "form-control",
                            on: {
                              change: [
                                function($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function(o) {
                                      return o.selected
                                    })
                                    .map(function(o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.selectedUserPlaceId = $event.target
                                    .multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                },
                                _vm.syncUserPlaceData
                              ]
                            }
                          },
                          [
                            _c("option", { attrs: { value: "" } }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.$t(
                                      "message.booking.booking_step.please_select"
                                    )
                                  ) +
                                  "\n              "
                              )
                            ]),
                            _vm._v(" "),
                            _vm._l(_vm.state.userPlaces, function(userPlace) {
                              return _vm.state.userPlaceCities[userPlace.id] ===
                                _vm.professional.province_id
                                ? _c(
                                    "option",
                                    { domProps: { value: userPlace.id } },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(userPlace.place_name) +
                                          "\n              "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            })
                          ],
                          2
                        )
                      ])
                    ])
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.parentServiceId === 1
              ? _c("div", { staticClass: "row mt-3" }, [
                  _c("div", { staticClass: "col-12" }, [
                    _c("div", { staticClass: "form-group mb-2" }, [
                      _c("h4", { staticClass: "pb-2" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("message.booking.booking_step.accommodation")
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "select-jumbo" }, [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.selectedPlaceSize,
                                expression: "selectedPlaceSize"
                              }
                            ],
                            staticClass: "form-control",
                            on: {
                              change: [
                                function($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function(o) {
                                      return o.selected
                                    })
                                    .map(function(o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.selectedPlaceSize = $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                },
                                _vm.setWorkHour
                              ]
                            }
                          },
                          _vm._l(_vm.sortedPlaceSizes, function(
                            placeSize,
                            index
                          ) {
                            return _c(
                              "option",
                              {
                                domProps: {
                                  value: _vm.sortedPlaceSizes[index].id
                                }
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm._f("multiLangName")(placeSize)) +
                                    "\n              "
                                )
                              ]
                            )
                          }),
                          0
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "text-primary pl-1" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t("message.booking.booking_step.recommend")
                          ) +
                          " " +
                          _vm._s(
                            _vm.$t(
                              _vm.globalState.durations[_vm.selectedPlaceSize]
                            )
                          ) +
                          "\n        "
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "select-jumbo mt-2" }, [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.selectedWorkHour,
                              expression: "selectedWorkHour"
                            }
                          ],
                          staticClass: "form-control",
                          on: {
                            change: [
                              function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.selectedWorkHour = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              },
                              _vm.initAvailableTimes
                            ]
                          }
                        },
                        _vm._l(_vm.globalState.workHours, function(
                          workHour,
                          index
                        ) {
                          return _c("option", { domProps: { value: index } }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t(workHour)) +
                                "\n            "
                            )
                          ])
                        }),
                        0
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "mt-2 pl-1 text-danger" }, [
                      _vm._v(
                        "\n          * " +
                          _vm._s(
                            _vm.$t(
                              "message.booking.new_booking.excluding_break_time"
                            )
                          ) +
                          "\n        "
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "mt-2 pl-1" },
                      [
                        _c("span", { staticClass: "text-danger" }, [
                          _vm._v("*")
                        ]),
                        _vm._v(" "),
                        _c(
                          "i18n",
                          {
                            attrs: {
                              path:
                                "message.booking.new_booking.big_cleaning_remark"
                            }
                          },
                          [
                            _c(
                              "router-link",
                              {
                                attrs: {
                                  slot: "link",
                                  to: "/service-requests/booking?service_id=13"
                                },
                                slot: "link"
                              },
                              [_vm._v("Big Cleaning")]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass: "text-danger",
                                attrs: { slot: "caution" },
                                slot: "caution"
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "message.booking.new_booking.big_cleaning_caution"
                                    )
                                  )
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ])
              : _vm.parentService && _vm.parentService.child_services_text
              ? _c("div", { staticClass: "row mt-3" }, [
                  _c("div", { staticClass: "col-12" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _vm.parentService && _vm.parentService.child_services_text
                        ? _c("h4", { staticClass: "pb-2" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.$i18n.locale === "th"
                                    ? _vm.parentService.child_services_text
                                        .title_th
                                    : _vm.parentService.child_services_text
                                        .title_en
                                ) +
                                "\n          "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "select-jumbo",
                          class: { "form-alert": _vm.errorSelectedService }
                        },
                        [
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.selectedServiceId,
                                  expression: "selectedServiceId"
                                }
                              ],
                              on: {
                                change: function($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function(o) {
                                      return o.selected
                                    })
                                    .map(function(o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.selectedServiceId = $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                }
                              }
                            },
                            [
                              _c("option", { domProps: { value: null } }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.$i18n.locale === "th"
                                        ? _vm.parentService.child_services_text
                                            .placeholder_th
                                        : _vm.parentService.child_services_text
                                            .placeholder_en
                                    ) +
                                    "\n              "
                                )
                              ]),
                              _vm._v(" "),
                              _vm._l(_vm.childServices, function(
                                service,
                                index
                              ) {
                                return _c(
                                  "option",
                                  {
                                    domProps: {
                                      value: _vm.childServices[index].id
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm._f("multiLangName")(service)
                                        ) +
                                        "\n              "
                                    )
                                  ]
                                )
                              })
                            ],
                            2
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _vm.errorSelectedService
                        ? _c(
                            "div",
                            { staticClass: "form-alert-text -status-alert" },
                            [_vm._v(_vm._s(_vm.errorSelectedServiceText))]
                          )
                        : _vm._e()
                    ])
                  ])
                ])
              : _vm.parentService && _vm.parentService.has_service_items
              ? _c("div", { staticClass: "row mt-3" }, [
                  _c("div", { staticClass: "col-12" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex justify-content-start align-items-center"
                      },
                      [
                        _c("div", { staticClass: "flex-fill" }, [
                          _c("h4", [
                            _vm._v(
                              _vm._s(_vm.$t("message.service_item.select"))
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _vm.serviceItems
                          ? _c("div", [
                              _c(
                                "a",
                                {
                                  staticClass: "text-info",
                                  attrs: { href: "" },
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      return _vm.clearSelectedServiceItems()
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.$t("message.service_item.clear")
                                      ) +
                                      "\n            "
                                  )
                                ]
                              )
                            ])
                          : _vm._e()
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "card pointer-item mb-1",
                        class: [
                          _vm.errorServiceItems
                            ? "border-danger"
                            : "border-divider"
                        ],
                        on: {
                          click: function($event) {
                            return _vm.openServiceItemModal()
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "card-body" }, [
                          !_vm.serviceItems
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex justify-content-start align-items-center"
                                },
                                [
                                  _c("div", [
                                    _c("img", {
                                      attrs: {
                                        src: _vm.parentService.icon_url,
                                        width: "24"
                                      }
                                    })
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "flex-fill px-3" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("message.service_item.select")
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _vm._m(0)
                                ]
                              )
                            : _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex justify-content-start align-items-top"
                                },
                                [
                                  _c("div", [
                                    _c("img", {
                                      staticClass: "active-svg-icon",
                                      attrs: {
                                        src: _vm.parentService.icon_url,
                                        width: "32"
                                      }
                                    })
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "flex-fill px-3" },
                                    [
                                      _c("div", { staticClass: "mb-2" }, [
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "message.service_item.list_of_items"
                                              )
                                            )
                                          )
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _vm._l(_vm.serviceItems, function(
                                        serviceItem
                                      ) {
                                        return _c("div", [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm._f("multiLangName")(
                                                  serviceItem
                                                )
                                              ) +
                                              ": " +
                                              _vm._s(serviceItem.count) +
                                              " " +
                                              _vm._s(
                                                _vm._f("multiLangName")(
                                                  serviceItem.item_unit
                                                )
                                              ) +
                                              "\n                "
                                          )
                                        ])
                                      })
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _vm._m(1)
                                ]
                              ),
                          _vm._v(" "),
                          _vm.serviceItems
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex justify-content-start align-items-center"
                                },
                                [
                                  _c("div", [_vm._v("      ")]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "text-info mt-2" }, [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.$t("message.service_item.remark")
                                        ) +
                                        "\n              "
                                    )
                                  ])
                                ]
                              )
                            : _vm._e()
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _vm.errorServiceItems
                      ? _c(
                          "div",
                          { staticClass: "form-alert-text -status-alert" },
                          [_vm._v(_vm._s(_vm.$t("message.required_selection")))]
                        )
                      : _vm._e()
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.packageType
              ? _c("div", { staticClass: "row mt-3" }, [
                  _c("div", { staticClass: "col-12" }, [
                    _c("h4", { staticClass: "pb-2" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("message.booking.new_booking.pick_a_date")
                        )
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-12 mb-4" },
                    [
                      _c("div", { staticClass: "text-remark mt-1" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.$t(
                                "message.booking.new_booking.select_multi_dates"
                              )
                            ) +
                            " - " +
                            _vm._s(_vm._f("multiLangName")(_vm.packageType)) +
                            "\n        "
                        )
                      ]),
                      _vm._v(" "),
                      _c("professional-multi-dates-calendar", {
                        attrs: {
                          professionalId: _vm.professionalId,
                          maxNum: _vm.packageType.num_per_package,
                          workHours: _vm.selectedWorkHour,
                          packageType: _vm.packageType
                        },
                        on: {
                          updateData: _vm.updateMultiDates,
                          updateNumPackageSelectedDates:
                            _vm.updateNumPackageSelectedDates
                        }
                      }),
                      _vm._v(" "),
                      _vm.multiDates && _vm.multiDates.length > 0
                        ? _c(
                            "section",
                            { staticClass: "mt-4" },
                            _vm._l(_vm.multiDates, function(date) {
                              return _c(
                                "span",
                                {
                                  staticClass:
                                    "badge badge-pill py-2 px-3 mr-2 mb-2 badge-light"
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(_vm._f("shortDate")(date)) +
                                      "\n          "
                                  )
                                ]
                              )
                            }),
                            0
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.errorBookingDate
                        ? _c(
                            "div",
                            { staticClass: "form-alert-text -status-alert" },
                            [_vm._v(_vm._s(_vm.errorBookingDateText))]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ])
              : _c("div", { staticClass: "row mt-3" }, [
                  _c("div", { staticClass: "col-12" }, [
                    _c("h4", { staticClass: "pb-2" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("message.booking.new_booking.pick_a_date")
                        )
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-6 pr-2" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "pikaday",
                            rawName: "v-pikaday:professionalCalendar",
                            value: _vm.professionalCalendar,
                            expression: "professionalCalendar",
                            arg: "professionalCalendar"
                          }
                        ],
                        ref: "cleaningDate",
                        staticClass: "form-control -date-picker input-jumbo",
                        class: { "form-alert": _vm.errorBookingDate },
                        attrs: {
                          type: "text",
                          placeholder: "DD/MM/YYYY",
                          readonly: ""
                        },
                        on: { change: _vm.displayAvailableDuration }
                      }),
                      _vm._v(" "),
                      _c("span", {
                        staticClass: "far fa-calendar-alt input-text-icon"
                      }),
                      _vm._v(" "),
                      _vm.errorBookingDate
                        ? _c(
                            "div",
                            { staticClass: "form-alert-text -status-alert" },
                            [_vm._v(_vm._s(_vm.errorBookingDateText))]
                          )
                        : _vm._e()
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-6 pl-2" }, [
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        !_vm.isFetchingProfessionalCalendarJobs
                          ? [
                              _vm.availableTimes.length > 0
                                ? _c("div", [
                                    _c("div", { staticClass: "select-jumbo" }, [
                                      _c(
                                        "select",
                                        {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.selectedTime,
                                              expression: "selectedTime"
                                            }
                                          ],
                                          staticClass: "form-control",
                                          staticStyle: { background: "white" },
                                          on: {
                                            change: function($event) {
                                              var $$selectedVal = Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function(o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function(o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })
                                              _vm.selectedTime = $event.target
                                                .multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            }
                                          }
                                        },
                                        _vm._l(_vm.availableTimes, function(
                                          time
                                        ) {
                                          return _c(
                                            "option",
                                            { domProps: { value: time } },
                                            [_vm._v(_vm._s(time))]
                                          )
                                        }),
                                        0
                                      ),
                                      _vm._v(" "),
                                      _c("span", {
                                        staticClass:
                                          "far fa-clock input-text-icon"
                                      })
                                    ])
                                  ])
                                : _vm.selectedDate === null
                                ? _c("div", { staticClass: "select-jumbo" }, [
                                    _c("div", { staticClass: "select-jumbo" }, [
                                      _c(
                                        "select",
                                        {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.selectedTime,
                                              expression: "selectedTime"
                                            }
                                          ],
                                          staticClass: "form-control",
                                          staticStyle: { background: "white" },
                                          on: {
                                            change: function($event) {
                                              var $$selectedVal = Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function(o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function(o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })
                                              _vm.selectedTime = $event.target
                                                .multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            }
                                          }
                                        },
                                        _vm._l(_vm.globalState.times, function(
                                          time
                                        ) {
                                          return _c(
                                            "option",
                                            { domProps: { value: time } },
                                            [_vm._v(_vm._s(time))]
                                          )
                                        }),
                                        0
                                      ),
                                      _vm._v(" "),
                                      _c("span", {
                                        staticClass:
                                          "far fa-clock input-text-icon"
                                      })
                                    ])
                                  ])
                                : _c("div", [
                                    _c("span", { staticClass: "text-orange" }, [
                                      _vm._v(
                                        _vm._s(_vm.$t("message.alert.sold_out"))
                                      )
                                    ])
                                  ])
                            ]
                          : [
                              _c("div", { staticClass: "text-center" }, [
                                _c("img", {
                                  attrs: {
                                    src: "/static/img/ring.gif",
                                    width: "32"
                                  }
                                }),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("message.button.loading")) +
                                    "\n            "
                                )
                              ])
                            ]
                      ],
                      2
                    )
                  ])
                ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.$t("message.booking.new_booking.booking_today_remark")
                    ) +
                    "\n        "
                ),
                _c(
                  "a",
                  {
                    attrs: {
                      href: "https://line.me/R/ti/p/%40hnk7011n",
                      target: "_blank"
                    }
                  },
                  [_vm._v("@beneat")]
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _vm.partialBlockedDuration
                ? _c("div", { staticClass: "col-md-12 mb-1" }, [
                    _c(
                      "ul",
                      { staticClass: "list-unstyled calendar-job-list" },
                      [
                        _c("li", [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.$t("message.professional.available_time")
                              ) +
                              ":\n            "
                          ),
                          _c("span", { staticClass: "text-primary" }, [
                            _vm.partialBlockedDuration === ""
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("message.professional.all_day")
                                    )
                                  )
                                ])
                              : _c("span", [
                                  _vm._v(_vm._s(_vm.partialBlockedDuration))
                                ])
                          ])
                        ]),
                        _vm._v(" "),
                        _vm.professionalCalendarJobs
                          ? _vm._l(_vm.professionalCalendarJobs, function(job) {
                              return _c("li", [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$t(
                                        "message.professional.booked_by_other_user"
                                      )
                                    ) +
                                    ":\n              "
                                ),
                                _c("span", {
                                  staticClass: "text-orange",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.$options.filters.cleaningDuration(
                                        job.cleaning_date,
                                        job.work_hour
                                      )
                                    )
                                  }
                                })
                              ])
                            })
                          : _vm._e()
                      ],
                      2
                    )
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row mt-3" }, [
              _c("div", { staticClass: "col-md-12" }, [
                _c("ul", { staticClass: "list-unstyled summary-list" }, [
                  _c("li", [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-8 p-0" }, [
                        _c("h3", { staticClass: "mb-2" }, [
                          _vm._v(
                            "\n                  " +
                              _vm._s(
                                _vm.$t("message.booking.new_booking.subtotal")
                              ) +
                              "\n                "
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-4 p-0 text-right" }, [
                        _c("h3", { staticClass: "mb-2 text-primary" }, [
                          _vm._v(
                            "\n                  " +
                              _vm._s(
                                _vm._f("currencyNoDecimal")(_vm.totalPrice)
                              ) +
                              "\n                "
                          )
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _vm.professional.active === 0
                ? _c("div", { staticClass: "col-12 text-danger mb-2" }, [
                    _c("hr", { staticClass: "no-space" }),
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("message.professional.inactive_status")) +
                        "\n      "
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-12 text-center" },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-info btn-block",
                      attrs: {
                        disabled:
                          _vm.professional.active === 0 ||
                          _vm.professional.professional_group_id > 1
                      },
                      on: {
                        click: function($event) {
                          return _vm.checkProfessionalAvailable()
                        }
                      }
                    },
                    [
                      _vm.professional.is_favorited_user
                        ? [
                            _c("i", {
                              staticClass:
                                "fas fa-bolt -status-instant-book -button"
                            }),
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t(_vm.isCheckingTextInstantBook)) +
                                "\n          "
                            )
                          ]
                        : [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t(_vm.isCheckingText)) +
                                "\n          "
                            )
                          ]
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _vm.$mq.desktop &&
                  _vm.user &&
                  _vm.hasPaidOrder &&
                  _vm.professional.active === 1
                    ? [
                        _c("div", { staticClass: "my-1" }, [
                          _vm._v(
                            "- " + _vm._s(_vm.$t("message.hero.or")) + " -"
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "router-link",
                          {
                            staticClass: "btn btn-outline-info btn-block",
                            attrs: {
                              tag: "a",
                              to: {
                                path: "/message",
                                query: { cid: 0, pid: _vm.$route.params.id }
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.$t("message.professional.contact_cleaner")
                                ) +
                                "\n          "
                            )
                          ]
                        )
                      ]
                    : _vm._e()
                ],
                2
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _vm._m(2),
              _vm._v(" "),
              _c("div", { staticClass: "col-10 col-lg-10 text-recommend" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.$t(
                        "message.booking.choose_cleaner_step.book_on_beneat_cleaning"
                      )
                    ) +
                    "\n        "
                ),
                _c(
                  "a",
                  {
                    staticClass: "text-primary-link",
                    attrs: { href: "/safety", target: "_blank" }
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$t(
                            "message.booking.choose_cleaner_step.learn_more"
                          )
                        ) +
                        "\n        "
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _vm._m(3)
            ])
          ])
        : _c("section", [_c("loader")], 1),
      _vm._v(" "),
      _vm.parentService && _vm.parentService.has_service_items
        ? _c("service-item-modal", {
            ref: "serviceItemModal",
            attrs: { parentService: _vm.parentService },
            on: { selectServiceItems: _vm.setServiceItems }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("i", { staticClass: "fal fa-plus-circle text-info fa-lg" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c(
        "button",
        { staticClass: "btn btn-sm btn-outline-info rounded-pill" },
        [_vm._v("แก้ไข")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12" }, [_c("hr")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-2 col-lg-2" }, [
      _c("img", {
        staticClass: "img-fluid",
        attrs: { src: "/static/img/ic-idea.svg" }
      })
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7bb8a5e0", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7bb8a5e0","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/professional/components/BookCleanerForm.vue
// module id = 1958
// module chunks = 0